// extracted by mini-css-extract-plugin
module.exports = {"address":"HULAddress_address__3Wg9v"};